document.addEventListener('DOMContentLoaded', function () {

  function updateRatings() {
    // this div has the data-* attributes we need
    var badges = document.querySelectorAll('.jdgm-prev-badge');
    //console.log(badges , 'badges')

    badges.forEach(function (badge) {
      var avg   = badge.getAttribute('data-average-rating');
      var count = badge.getAttribute('data-number-of-reviews');

      if (!avg || !count) return;

    // If no rating OR count === "0", hide the rating container entirely
      if (!avg || !count || count === "0") {
        var emptyCard = badge.closest('.grid__item');
        if (emptyCard) {
          var emptyContainer = emptyCard.querySelector('.product-card-rating');
          if (emptyContainer) emptyContainer.style.display = "none";
        }
        return; // stop here
      }

      // go up to the product tile
      var card = badge.closest('.grid__item'); 
      // check if it is a carousel tile
      if (!card) 
        card = badge.closest('.carousel__item');
      if (!card) return;

      var ratingContainer = card.querySelector('.product-card-rating');
      if (!ratingContainer) return;

      ratingContainer.innerHTML = `
        <span class="jdgm-star jdgm--on"></span>
        <span class="jdgm-prev-badge__text">${parseFloat(avg).toFixed(1)}</span>
        <span class="product-card-rating__count">(${count})</span>
      `;
    });
  }

  // run once and then again after Judge.me finishes injecting HTML
  updateRatings();
  setTimeout(updateRatings, 1500);
});